<!-- eslint-disable vue/no-v-html -->
<template>
	<div
		class="c-Icon"
		:class="iconStyle"
		:style="{ width: `${width}px`, height: `${height}px` }"
		v-html="require(`../../icons/${icon}.svg`)"
	/>
</template>

<script>
export default {
	name: 'Icon',
	props: {
		/**
     * The Icon name that should be displayed
     */
		icon: {
			type: String,
			required: true,
			default: () => 'alarm'
		},
		/**
     * The Icon width (in px)
     */
		width: {
			type: Number,
			required: false,
			default: () => 24
		},
		/**
     * The Icon height (in px)
     */
		height: {
			type: Number,
			required: false,
			default: () => 24
		},
		/**
     * Icon style (colors)
     * @values is-primary, is-primary-inverted, is-transparent, is-added, is-important, is-alert, is-dark-gray, is-disabled-gray, is-white, is-black
     */
		iconStyle: {
			type: String,
			required: false,
			default: () => 'is-primary',
			validator (style) {
				return [
					'is-primary',
					'is-primary-inverted',
					'is-transparent',
					'is-added',
					'is-important',
					'is-alert',
					'is-dark-gray',
					'is-disabled-gray',
					'is-white',
					'is-black'
				].includes(style)
			}
		}
	}
}
</script>

<style lang="scss">
@import '../../scss/variables.scss';
.c-Icon {
	svg {
		width: inherit !important;
		height: inherit !important;
	}

	&.is-primary svg path {
		fill: $un-blue;
	}
	&.is-primary-inverted svg path {
		fill: $un-white;
	}
	&.is-transparent svg path {
		fill: none;
	}
	&.is-added svg path {
		fill: $un-green-button;
	}
	&.is-important svg path {
		fill: $un-yellow;
	}
	&.is-alert svg path {
		fill: $un-red;
	}
	&.is-dark-gray svg path {
		fill: $un-gray4-light;
	}
	&.is-disabled-gray svg path {
		fill: $un-n500;
	}
	&.is-white svg path {
		fill: $un-white;
	}
	&.is-black svg path {
		fill: $un-black;
	}
}
</style>
